<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 11 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 -0.000469212L11 5.49953L10.23 6.26953L5.5 1.53953L0.77 6.26953L6.73155e-08 5.49953L5.5 -0.000469212Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 11,
  },
  height: {
    type: [String, Number],
    default: 7,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>